import {
    Component,
    createNgModuleRef,
    Injector,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'cloud-automation-designer-home-dynamic-load',
    template: '<ng-container #container></ng-container>',
    standalone: false
})
export class CloudAutomationDesignerLoadDynamic implements OnInit {
    @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;


    constructor(
        private route: ActivatedRoute,
        private injector: Injector
    ) { }
    ngOnInit(): void {
        this.loadDynamicComponent();
    }

    async loadDynamicComponent() {
        const routeSegments = this.route.snapshot.url; // Get the route segments
        const lastSegmentIndex = routeSegments.length - 1;
        const componentName = routeSegments[lastSegmentIndex].path; // Extract the last segment

        // Dynamically load the component based on the last segment
        const { CloudAutomationDesignerModule } = await import('./cloud-automation-designer.module');
        const componentToLoad = this.getComponentToLoad(CloudAutomationDesignerModule, componentName);
        const moduleRef = createNgModuleRef(CloudAutomationDesignerModule, this.injector);
        this.container.createComponent(componentToLoad, { ngModuleRef: moduleRef });
    }

    // Function to map the segment to the respective component
    getComponentToLoad(module: any, componentName: string): any {
        switch (componentName) {
        case 'designer':
            return module.components.designerComponent;
        case 'documentation':
            return module.components.documentationComponent;
        case 'analysis':
            return module.components.monitorComponent;
        default:
            return module.components.homeComponent;
        }
    }

}